import {
   Card,
   Flex,
   Text,
   Button,
   Box,
   Input,
   Select,
   useColorModeValue,
   useBreakpointValue,
   useOutsideClick,
   useDisclosure,
   useToast,
   IconButton,
   ModalFooter,
   Switch,
   FormLabel,
   SimpleGrid,
   ModalBody,
   ModalCloseButton,
   ModalHeader,
   ModalContent,
   ModalOverlay,
   Modal,
   Spinner, // Add Spinner import
   Center,
   useColorMode, // Add Center import
} from '@chakra-ui/react';
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';

// UI
import Menu from 'components/menu/MainMenu';
import DynamicDataTable from '../masters/components/DynamicDataTable';

import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import { SearchIcon } from '@chakra-ui/icons';

import { useFilterData, downloadPDF, downloadExcel } from '../../../utils/DataTableUtils';
import { deleteRecord, deleteRecordForSales } from '../../../utils/util';
import SalesDetails from 'components/salesDetails/SalesDetails';
import TransactionDetailModal from 'views/admin/masters/components/TransactionDetailModel';
import DeletePasswordModal from 'views/admin/sales/Pages/SalesInvoiceMaster/DeletePasswordModal';
import MultiDeletePasswordModal from 'views/admin/sales/Pages/SalesInvoiceMaster/MultiDeletePasswordModal';

// ACTION
import {
   deletePurchaseInvoice,
   // emptyPurchase,
   getSinglePurchaseWithPrevAndNext,
   deleteMultiPurchaseInvoice,
} from '../../../redux/actions/purchaseInvoice';
import { postColumnsHideShow } from '../../../redux/actions/utility';

import { useDispatch } from 'react-redux';
import { useUser, useGlobal } from 'contexts';
import SalesInvoiceFilterModal from 'views/admin/sales/Pages/SalesInvoiceMaster/SalesInvoiceFilterModal';
import { IoFilterOutline } from 'react-icons/io5';
import { AiTwotoneBook } from 'react-icons/ai';
import { BsEye } from 'react-icons/bs';
import { FiRefreshCcw } from 'react-icons/fi';
import { X } from 'lucide-react';
import Loader from 'views/admin/default/Loader';
import { getPurchaseChallans, deletePurchaseChallan, deleteMultiPurchasechallanInvoice, emptyPurchase } from '../../../redux/actions/PurchaseChallan';
import { getDaybook } from '../../../redux/actions/daybook';
import { getItem } from '../../../redux/actions/item';
import { getAccount } from '../../../redux/actions/account';

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const PurchaseInvoice = () => {
   const path = window.location.pathname;
   const daybookId = path.split('/').pop();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const backgroundColor = useColorModeValue('#ECFCFF', 'rgba(12, 20, 41, 1)');
   const hoverBg = useColorModeValue('gray.200', 'gray.600');
   const [isRotating, setIsRotating] = useState(false);
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const { user } = useUser();
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const { isOpen, onOpen, onClose } = useDisclosure();
   const {
      isOpen: isBillToBillModal,
      onOpen: onOpenBillToBillModal,
      onClose: onCloseBillToBillModal,
   } = useDisclosure();
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [multiPass, setMultiPass] = useState(false);
   const [multiDeleteData, setMultiDeleteData] = useState(null);
   const [dataId, setDataId] = useState(null);
   const daybookData = useSelector((state) => state.daybook?.list || []);
   const purchaseChallan = useSelector((state) => state.purchaseChallan?.list || []);

   const Totals = useSelector((state) => state.purchaseChallan.pagination.totals);
   const isLoading = useSelector((state) => state.purchaseChallan.isLoading);
   const pagination = useSelector((state) => state.purchaseChallan?.pagination);
   const totalCount = useSelector((state) => state.purchaseChallan?.totalCount);
   // const singleEntity = useSelector((state) => state?.purchaseChallan?.single || {});
   const [singleEntity, setSingleEntity] = useState(null);
   const daybookTypeData = useSelector(
      (state) => state.purchaseChallan?.pagination?.totals?.TotalDaybookBalance || null,
   );
   const viewData = singleEntity;
   const account = useSelector((state) => state.account.single);
   const [currentPage, setCurrentPage] = useState('');
   const [limit, setLimit] = useState(10);
   const [data, setData] = useState([]);
   const [isEditingPage, setIsEditingPage] = useState(false);
   const [pageInputValue, setPageInputValue] = useState('');
   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const [expanded, setExpanded] = useState(false);
   const [isOpenSingleView, setIsOpenSingleView] = useState(false);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isDropdownOpen, setDropdownOpen] = useState(false);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [paginateData, setPaginateData] = useState({});
   const Admin = user?.isAdmin;
   const [accountId, setAccountId] = useState(null);
   const [companyId, setCompanyId] = useState(null);
   const [invoiceData, setInvoiceData] = useState(null);
   const [isInitialLoad, setIsInitialLoad] = useState(true); // Add initial load state
   const [isSearching, setIsSearching] = useState(false); // Add searching state
   const [isFiltering, setIsFiltering] = useState(false); // Add filtering state
   const [isModalLoading, setIsModalLoading] = useState(false);
   const [isPageChanging, setIsPageChanging] = useState(false);
   const purchaseChallanRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === user?.loginhistory?.companyId)?.purchasechallan
      : null;

   const { viewDetail, paginate } = useMemo(() => {
      const data = viewData;
      const pagination = viewData?.pagination;
      return { viewDetail: data, paginate: pagination };
   }, [viewData]);
   const DEFAULT_PURCHASE_COLUMNS = {
      docno: true,
      transactionAt: true,
      partyNo: true,
      partyDate: true,
      daybookname: true,
      itemname: true,
      serialno: true,
      accountname: true,
      qty1: false,
      qty2: false,
      qty3: false,
      taxableAmount: true,
      gstAmount: true,
      netAmount: true,
      pendingamt: true,
      // pendingstatus: true,
      createdu: false,
      updatedu: false,
      // status: false,
      action: true,
   };

   const [columnVisibility, setColumnVisibility] = useState(() => {
      // First, check if we have saved visibility in localStorage
      const savedVisibility = localStorage.getItem('purchaseChallanColumnVisibility');
      if (savedVisibility) {
         try {
            const parsed = JSON.parse(savedVisibility);
            // Merge with defaults to ensure any new columns are included
            return { ...DEFAULT_PURCHASE_COLUMNS, ...parsed };
         } catch (error) {
            console.error('Error parsing saved column visibility:', error);
         }
      }

      // If no saved visibility, check user settings
      if (user?.viewJson?.length && user.viewJson[0]?.sales) {
         return { ...DEFAULT_PURCHASE_COLUMNS, ...user.viewJson[0].sales };
      }

      // Fallback to defaults
      return DEFAULT_PURCHASE_COLUMNS;
   });
   const [isColumnModalOpen, setIsColumnModalOpen] = useState(false);
   const [sorting, setSorting] = useState([]);

   const columnsData = useMemo(
      () => [
         { id: 'docno', header: 'DOC NO', accessor: 'docno' },
         { id: 'transactionAt', header: 'DOC Date', accessor: 'transactionAt' },
         { id: 'partyNo', header: 'Bill No', accessor: 'partyNo' },
         { id: 'partyDate', header: 'Party Date', accessor: 'partyDate' },
         { id: 'daybookname', header: 'Daybook', accessor: 'daybookname' },
         {
            id: 'itemname',
            header: 'Item',
            accessor: 'itemname',
         },
         {
            id: 'serialno',
            header: 'serial No',
            accessor: 'serialno',
         },
         { id: 'accountname', header: 'Party', accessor: 'accountname' },
         { id: 'qty1', header: 'Qty 1', accessor: 'qty1' },
         { id: 'qty2', header: 'Qty 2', accessor: 'qty2' },
         { id: 'qty3', header: 'Qty 3', accessor: 'qty3' },
         {
            id: 'taxableAmount',
            header: (
               <Box>
                  <Text>Taxable Amount</Text>
                  {Totals?.totalTaxableAmount > 0 && (
                     <Text fontSize="xs" color="gray.500" display="inline-flex" alignItems="baseline">
                        (₹{' '}
                        {
                           Totals.totalTaxableAmount
                              .toLocaleString('en-IN', {
                                 minimumFractionDigits: 2,
                                 maximumFractionDigits: 2,
                              })
                              .split('.')[0]
                        }
                        )
                     </Text>
                  )}
               </Box>
            ),
            accessor: 'taxableAmount',
         },
         {
            id: 'gstAmount',
            header: 'GST',
            accessor: 'gstAmount',
         },
         {
            id: 'netAmount',
            header: (
               <Box>
                  <Text>Net Amount</Text>
                  {Totals?.totalNetAmount > 0 && (
                     <Text fontSize="xs" color="gray.500" display="inline-flex" alignItems="baseline">
                        (₹{' '}
                        {
                           Totals.totalNetAmount
                              .toLocaleString('en-IN', {
                                 minimumFractionDigits: 2,
                                 maximumFractionDigits: 2,
                              })
                              .split('.')[0]
                        }
                        )
                     </Text>
                  )}
               </Box>
            ),
            accessor: 'netAmount',
         },
         {
            id: 'pendingamt',
            header: (
               <Box>
                  <Text>Pending Amount</Text>
                  {Totals?.totalPendingAmount > 0 && (
                     <Text fontSize="xs" color="gray.500" display="inline-flex" alignItems="baseline">
                        (₹{' '}
                        {
                           Totals.totalPendingAmount
                              .toLocaleString('en-IN', {
                                 minimumFractionDigits: 2,
                                 maximumFractionDigits: 2,
                              })
                              .split('.')[0]
                        }
                        )
                     </Text>
                  )}
               </Box>
            ),
            accessor: 'pendingamt',
         },
         // {
         //    id: 'pendingstatus',
         //    header: 'Payment Status',
         //    accessor: 'pendingstatus',
         // },
         { id: 'createdu', header: 'Created By', accessor: 'createdu' },
         { id: 'updatedu', header: 'Updated By', accessor: 'updatedu' },
         // { id: 'status', header: 'STATUS', accessor: 'status' },
      ],
      [],
   );
   const [filters, setFilters] = useState({
      pendingstatus: 'all',
      purchaseStatus: 'all',
      invoiceBook: 'all',
      duration: 'any',
      contact: '',
      item: '',
      docno: '',
      daybookIds: '',
      accountIds: '',
      accountId: '',
      fromDate: '',
      toDate: '',
   });

   const handleApplyFilters = (newFilters) => {
      setIsFiltering(true); // Set filtering state when filters are applied
      setFilters(newFilters);
      let count = 0;
      if (newFilters.pendingstatus !== 'all') count++;
      if (newFilters.purchaseStatus !== 'all') count++;
      if (newFilters.invoiceBook !== 'all') count++;
      if (newFilters.duration !== 'any') count++;
      if (newFilters.contact) count++;
      if (newFilters.item) count++;
      if (newFilters.docno) count++;
      if (newFilters.daybookIds) count++;
      if (newFilters.accountIds) count++;
      if (newFilters.accountId) count++;
      if (newFilters.fromDate) count++;
      if (newFilters.toDate) count++;
      setCurrentPage(1);
   };

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      ?.map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const wrapperRef = useRef();

   const filteredData = useFilterData(data, debouncedSearchQuery, columns);

   const handlePageChange = useCallback(
      (directionOrPage) => {
         setIsPageChanging(true);
         if (typeof directionOrPage === 'number') {
            setCurrentPage(directionOrPage);
         } else {
            setCurrentPage((prevPage) => {
               if (directionOrPage === 'next') {
                  return prevPage < pagination?.totalPages ? prevPage + 1 : prevPage;
               } else {
                  return prevPage > 1 ? prevPage - 1 : prevPage;
               }
            });
         }
      },
      [pagination?.totalPages],
   );

   const handlePageClick = () => {
      setIsEditingPage(true);
      setPageInputValue('');
   };

   const handlePageInputSubmit = () => {
      const page = parseInt(pageInputValue);
      if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
         handlePageChange(page);
      }
      setIsEditingPage(false);
      setPageInputValue('');
   };

   const handlePageInputBlur = () => {
      handlePageInputSubmit();
   };

   const handlePageKeyDown = (e) => {
      if (e.key === 'Enter') {
         handlePageInputSubmit();
      } else if (e.key === 'Escape') {
         setIsEditingPage(false);
         setPageInputValue('');
      }
   };

   const handlePageSizeChange = (e) => {
      const value = e.target.value;
      const newLimit = value === 'ALL' ? pagination?.totalProducts : Number(value);
      setLimit(newLimit);
      setCurrentPage(1);
   };
   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyIdDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;

   const deletePurchase = () => {
      const selectedData = data.filter((da) => da.id === viewDetail?.id);
      const selectedDaybook = daybookData.filter((dd) => dd.id === selectedData[0].daybookId);
      if (selectedDaybook.length > 0 && selectedDaybook[0]?.askPasswordOnDelete) {
         setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId });
         setIsModalOpen(true);
         onClose();
      } else {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail.daybookId,
            viewDetail.accountId,
            deletePurchaseChallan,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
         );
         onClose();
      }
      // deleteRecordForSales(
      //    viewDetail?.id,
      //    viewDetail.daybookId,
      //    viewDetail.accountId,
      //    deletePurchaseInvoice,
      //    dispatch,
      //    user?.loginhistory?.companyId,
      // );
      // onClose();
   };

   const handleViewSingleData = async (data) => {
      setIsModalLoading(true); // Use separate state
      onOpen(); // Open modal immediately

      try {
         setSingleEntity(data);
         // await dispatch(getPurchaseInvoice(id));
         setIsOpenSingleView(true);

         const currentIdx = purchaseChallan.findIndex((x) => x.id === data.id);
         const prevObject = currentIdx > 0 ? purchaseChallan[currentIdx - 1] : null;
         const nextObject = currentIdx < purchaseChallan.length - 1 ? purchaseChallan[currentIdx + 1] : null;

         // await dispatch(
         //    getSinglePurchaseWithPrevAndNext({
         //       id: id,
         //       page: 1,
         //       limit: 1,
         //       sortBy: 'id',
         //       sortOrder: 'desc',
         //       companyId: user?.loginhistory?.companyId,
         //    }),
         // );
         setPaginateData({
            hasPreviousPage: prevObject ? true : false,
            previousPage: prevObject ? currentIdx - 1 : null,
            nextPage: nextObject ? currentIdx + 1 : null,
            hasNextPage: nextObject ? true : false,
         });
         onOpen();
      } catch (error) {
         console.error('Error fetching sales data:', error);
      } finally {
         setIsModalLoading(false); // Update separate state
      }
   };

   const handlePrevPage = useCallback(
      async (page) => {
         setIsModalLoading(true);
         try {
            await dispatch(
               getSinglePurchaseWithPrevAndNext({
                  page: page,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
         } finally {
            setIsModalLoading(false);
         }
      },
      [dispatch],
   );
   const handleNextPage = useCallback(
      async (page) => {
         setIsModalLoading(true);
         try {
            await dispatch(
               getSinglePurchaseWithPrevAndNext({
                  page: page,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
         } finally {
            setIsModalLoading(false);
         }
      },
      [dispatch],
   );

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const handleMultiDelete = async (data) => {
      const res = await dispatch(deleteMultiPurchasechallanInvoice({ ids: data }));
      if (res?.code === 1) {
         getPurchase();
         if (user?.loginhistory?.companyId) {
            dispatch(
               getDaybook({
                  companyId: Number(user?.loginhistory?.companyId),
                  ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
            dispatch(
               getItem({
                  companyId: user?.loginhistory.companyId,
                  sortBy: 'name',
                  sortOrder: 'asc',
                  ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
            dispatch(
               getAccount({
                  compId: Number(user?.loginhistory?.companyId),
                  accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                  status: true,
                  ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
         }
      }
   };

   const handleOnClose = useCallback(() => {
      dispatch(emptyPurchase());
      setIsModalLoading(false);
      onClose();
   }, [dispatch, onClose]);

   const handleOnCloseBillToBill = useCallback(() => {
      setAccountId(null);
      setCompanyId(null);
      onCloseBillToBillModal();
   }, [onCloseBillToBillModal]);

   const getPurchase = useCallback(async () => {
      if (user && user?.loginhistory?.companyId && currentPage !== '') {
         const sortBy = sorting.length > 0 ? sorting[0]?.id : 'id';
         const sortOrder = sorting.length > 0 ? (sorting[0]?.desc ? 'DESC' : 'ASC') : 'DESC';

         // Set loading states based on current operation
         if (isFiltering || isSearching) {
            // These states are already set by their respective handlers
         }

         await dispatch(emptyPurchase());
         await dispatch(
            getPurchaseChallans({
               page: currentPage,
               limit: limit,
               search: debouncedSearchQuery,
               companyId: user?.loginhistory?.companyId,
               sortBy,
               sortOrder,
               paymentStatus: filters.paymentStatus !== 'all' ? filters.paymentStatus : undefined,
               purchaseStatus: filters.purchaseStatus !== 'all' ? filters.purchaseStatus : undefined,
               invoiceBook: filters.invoiceBook !== 'all' ? filters.invoiceBook : undefined,
               duration: filters.duration !== 'any' ? filters.duration : undefined,
               contact: filters.contact || undefined,
               item: filters.item || undefined,
               docno: filters.docno || undefined,
               daybookIds: daybookId !== 'challan' ? daybookId : filters.daybookIds || undefined,
               accountIds: filters.accountIds || undefined,
               accountId: filters.accountId || undefined,
               fromDate: filters.fromDate || undefined,
               toDate: filters.toDate || undefined,
            }),
         );

         setIsInitialLoad(false);
         setIsSearching(false);
         setIsFiltering(false);
         setIsPageChanging(false);
      }
   }, [
      currentPage,
      dispatch,
      filters.purchaseStatus,
      filters.accountId,
      filters.contact,
      filters.fromDate,
      filters.toDate,
      filters.docno,
      filters.daybookIds,
      filters.accountIds,
      filters.duration,
      filters.invoiceBook,
      filters.item,
      filters.paymentStatus,
      limit,
      debouncedSearchQuery,
      sorting,
      user,
      daybookId,
      isFiltering,
      isSearching,
   ]);

   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (debouncedSearchQuery === '') setExpanded(false);
      },
   });

   useEffect(() => {
      if (currentPage === '') {
         const page = localStorage.getItem('purchasechallanpage');
         setCurrentPage(page ? Number(page) : 1);
         localStorage.removeItem('purchasechallanpage');
      }
   }, [currentPage]);

   useEffect(() => {
      getPurchase();
   }, [getPurchase]);

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   useEffect(() => {
      const handleKeyDown = (event) => {
         // Check if the pressed key is '+' or '=' (since + is Shift + =)
         if ((event.key === '+' || (event.key === '=' && event.shiftKey)) && user && !user.isExpired) {
            // Prevent default behavior
            event.preventDefault();
            navigate('/admin/purchase/challan/add'); // it should be removed and sales challan right should be work
            // Check if user has permission to add challan (optional security check)
            if (Admin || purchaseChallanRight?.add) {
               // Navigate to add challan page
               navigate('/admin/purchase/challan/add');
            }
         }
      };

      // Add event listener to document
      document.addEventListener('keydown', handleKeyDown);

      // Cleanup function to remove event listener
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, [navigate, purchaseChallanRight?.add, Admin]); // Dependencies

   useEffect(() => {
      const handleKeyDown = (event) => {
         // Check if the target is an input, textarea, or contenteditable element
         const isInputElement =
            ['INPUT', 'TEXTAREA'].includes(event.target.tagName) || event.target.contentEditable === 'true';

         // Only trigger if not typing in an input field
         if (!isInputElement && (event.key === '+' || (event.key === '=' && event.shiftKey))) {
            event.preventDefault();

            if ((Admin || purchaseChallanRight?.add) && user && !user.isExpired) {
               navigate('/admin/purchase/challan/add');
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, [navigate, purchaseChallanRight?.add, Admin]);

   useEffect(() => {
      if (isOpenSingleView) {
         // dispatch(getAccountById({ id: singleEntity?.accountId, compId: user?.loginhistory?.companyId }));
      }
   }, [dispatch, isOpenSingleView, singleEntity?.accountId, user?.loginhistory?.companyId]);

   useEffect(() => {
      const admin = user?.isAdmin;
      const rights = user?.userRights?.find((ur) => ur?.companyId === user?.loginhistory?.companyId);
      if (user && !user?.packageData?.[0]?.purchase_challan && !(admin || rights?.purchasechallan?.view)) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      setPaginateData(paginate);
   }, [paginate]);

   useEffect(() => {
      setData(purchaseChallan);
      return () => { };
   }, [purchaseChallan]);

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
      }, 500),
      [],
   );

   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value);
      setIsSearching(true);
      debouncedSearchHandler(value);
   };

   useEffect(() => {
      localStorage.setItem('purchaseChallanColumnVisibility', JSON.stringify(columnVisibility));
   }, [columnVisibility]);
   // useEffect(() => {
   //    if (user?.viewJson?.length && user.viewJson[0]?.salesReturn) {
   //       const mergedVisibility = {
   //          ...DEFAULT_PURCHASE_COLUMNS,
   //          ...user.viewJson[0].salesReturn,
   //       };
   //       setColumnVisibility(mergedVisibility);
   //       // Also save to localStorage
   //       localStorage.setItem('salesReturnColumnVisibility', JSON.stringify(mergedVisibility));
   //    }
   // }, [user]);

   const ColumnVisibilityModal = ({ isOpen, onClose, columnVisibility, setColumnVisibility, user }) => {
      const [localVisibility, setLocalVisibility] = useState(columnVisibility);
      const companyId = Number(localStorage.getItem('companyId'));
      const dispatch = useDispatch();

      const { colorMode } = useColorMode();
      const isDark = colorMode === 'dark';

      useEffect(() => {
         if (isOpen) {
            setLocalVisibility(columnVisibility);
         }
      }, [isOpen, columnVisibility]);

      const handleToggle = (key) => {
         setLocalVisibility((prev) => ({ ...prev, [key]: !prev[key] }));
      };

      const handleSave = async () => {
         try {
            const updatedViewJson = user.viewJson
               ? user.viewJson.map((item) =>
                  item.companyId === companyId ? { ...item, sales: localVisibility } : item,
               )
               : [{ companyId, sales: localVisibility }];

            await dispatch(
               postColumnsHideShow({
                  userId: user?.id,
                  viewJson: updatedViewJson,
               }),
            );

            setColumnVisibility(localVisibility);
            localStorage.setItem('purchaseChallanColumnVisibility', JSON.stringify(localVisibility));
            onClose();
         } catch (error) {
            console.log(error);
         }
      };

      return (
         <Modal isOpen={isOpen} onClose={onClose} size="4xl">
            <ModalOverlay />
            <ModalContent
               bg={
                  isDark
                     ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 50%, #1e293b 100%)'
                     : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 50%, #ffffff 100%)'
               }
               border={isDark ? '1px solid #334155' : '1px solid #e2e8f0'}>
               <ModalHeader
                  borderBottom={isDark ? '1px solid #334155' : '1px solid #e2e8f0'}
                  bg={isDark ? 'rgba(30, 41, 59, 0.5)' : 'rgba(248, 250, 252, 0.5)'}>
                  <Flex justify="space-between" align="center">
                     <Box>
                        <Text color={isDark ? 'white' : 'gray.900'} fontSize="2xl" fontWeight="bold">
                           Show/Hide Columns
                        </Text>
                        <Text color={isDark ? 'gray.400' : 'gray.600'} fontSize="sm" mt={1}>
                           Customize which columns appear in your sales challan table
                        </Text>
                     </Box>
                  </Flex>
               </ModalHeader>

               <ModalCloseButton />

               <ModalBody maxH="60vh" overflowY="auto" py={6}>
                  <SimpleGrid columns={2} spacing={4}>
                     {Object.entries(localVisibility).map(([key, value]) => (
                        <Card
                           key={key}
                           p={5}
                           cursor="pointer"
                           border="2px solid"
                           borderColor={value ? (isDark ? 'blue.500' : 'blue.400') : isDark ? 'gray.600' : 'gray.300'}
                           bg={value ? (isDark ? 'blue.900/20' : 'blue.50/50') : isDark ? 'gray.800/30' : 'white/50'}
                           _hover={{ transform: 'scale(1.02)' }}
                           transition="all 0.3s"
                           onClick={() => handleToggle(key)}>
                           <Flex justify="space-between" align="center">
                              <FormLabel
                                 htmlFor={key}
                                 mb={0}
                                 fontWeight="semibold"
                                 color={isDark ? 'white' : 'gray.900'}
                                 cursor="pointer">
                                 {key.split(/(?=[A-Z])/).join(' ')}
                              </FormLabel>
                              <Switch
                                 id={key}
                                 isChecked={value}
                                 onChange={(e) => {
                                    e.stopPropagation();
                                    handleToggle(key);
                                 }}
                                 colorScheme="blue"
                                 size="lg"
                              />
                           </Flex>
                           <Flex align="center" gap={2} mt={3}>
                              <Box
                                 w={2}
                                 h={2}
                                 borderRadius="full"
                                 bg={value ? (isDark ? 'blue.400' : 'blue.500') : isDark ? 'gray.600' : 'gray.400'}
                              />
                              <Text
                                 fontSize="xs"
                                 fontWeight="medium"
                                 color={value ? (isDark ? 'blue.400' : 'blue.600') : isDark ? 'gray.500' : 'gray.500'}>
                                 {value ? 'Visible' : 'Hidden'}
                              </Text>
                           </Flex>
                        </Card>
                     ))}
                  </SimpleGrid>
               </ModalBody>

               <ModalFooter
                  borderTop={isDark ? '1px solid #334155' : '1px solid #e2e8f0'}
                  bg={isDark ? 'rgba(30, 41, 59, 0.5)' : 'rgba(248, 250, 252, 0.5)'}>
                  <Button
                     variant="ghost"
                     mr={3}
                     rounded={'md'}
                     onClick={onClose}
                     color={isDark ? 'gray.300' : 'gray.700'}
                     _hover={{ bg: isDark ? 'gray.700' : 'gray.200' }}>
                     Cancel
                  </Button>
                  <Button
                     className={`
              !px-6 !py-2.5 !rounded-lg !font-semibold !transition-all !duration-200 !shadow-lg
              ${isDark
                           ? '!bg-gradient-to-r !from-blue-600 !to-indigo-600 hover:!from-blue-500 hover:!to-indigo-500'
                           : '!bg-gradient-to-r !from-blue-500 !to-indigo-500 hover:!from-blue-600 hover:!to-indigo-600'
                        }
              !text-white
              ${isDark ? '!shadow-blue-500/30' : '!shadow-blue-400/30'}
              hover:!shadow-xl
              hover:!-translate-y-1
              active:!translate-y-0
            `}
                     onClick={handleSave}>
                     Save
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal>
      );
   };

   // Updated condition to show loader for any data fetching operation
   const shouldShowLoader =
      (isLoading && data.length === 0) || isInitialLoad || isSearching || isFiltering || isPageChanging;
   const handleRefreshData = async () => {
      setIsRotating(!isRotating);
      getPurchase();
      if (user?.loginhistory?.companyId) {
         dispatch(
            getDaybook({
               companyId: Number(user?.loginhistory?.companyId),
               ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(
            getItem({
               companyId: user?.loginhistory.companyId,
               sortBy: 'name',
               sortOrder: 'asc',
               ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(
            getAccount({
               compId: Number(user?.loginhistory?.companyId),
               accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
               status: true,
               ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   };

   return (
      <>
         <Box w="100%" bg={backgroundColor}>
            <Flex
               width={{ base: '100%', md: 'auto' }}
               mb="8px"
               px={{ base: '1px', md: '25px' }}
               justifyContent="space-between"
               align="center"
               overflowX="auto"
               flexWrap="nowrap"
               gap={3}>
               <Flex align="center" gap={4} flexShrink={0}>
                  <Text
                     color={textColor}
                     ml={{ base: '8px', md: 0 }}
                     fontSize={{ base: '17px', lg: '22px' }}
                     fontWeight="700"
                     lineHeight="100%">
                     Purchase Challan
                  </Text>
               </Flex>

               <Flex align="center" gap={2} flexShrink={0} p={3}>
                  {!isMobileOrTablet && (Admin || purchaseChallanRight?.add) && !user.isExpired && (
                     <button
                        onClick={() => navigate('/admin/purchase/challan/add')}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                           }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-cyan-100/20' : 'via-white/30'
                              }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark
                              ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                              : 'bg-white/20 group-hover:bg-white/30'
                              }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  )}
                  <Box>
                     <IconButton
                        icon={
                           <Box
                              as={FiRefreshCcw}
                              transform={isRotating ? 'rotate(-360deg)' : 'rotate(0deg)'}
                              transition="transform 1s ease"
                           />
                        }
                        aria-label="Refresh"
                        variant="ghost"
                        size="lg"
                        _hover={{ bg: hoverBg }}
                        isRound
                        onClick={handleRefreshData}
                     />
                  </Box>
                  <Box cursor={'pointer'} onClick={onFilterOpen}>
                     <IoFilterOutline size={22} />
                  </Box>
                  <Box cursor={'pointer'} onClick={() => navigate('/admin/purchase/challan/managedaybook')}>
                     <AiTwotoneBook size={22} />
                  </Box>
                  {/* Pagination Controls */}
                  <Flex align="center" flexShrink={0}>
                     <Box
                        onClick={() => handlePageChange('prev')}
                        cursor={currentPage > 1 ? 'pointer' : 'not-allowed'}
                        opacity={currentPage > 1 ? 1 : 0.5}
                        role="button"
                        aria-label="Previous page">
                        <MdNavigateBefore size={28} />
                     </Box>

                     {/* Current Page Display with Manual Input */}
                     <Flex align="center" mx="10px" position="relative">
                        {!isEditingPage ? (
                           <Flex align="center">
                              <Text
                                 as="span"
                                 fontSize={{ base: '14px', lg: '17px' }}
                                 minWidth="40px"
                                 textAlign="center"
                                 onClick={handlePageClick}
                                 cursor="pointer"
                                 border="2px solid"
                                 borderColor="blue.500"
                                 color="blue.600"
                                 fontWeight="medium"
                                 px={2}
                                 py={1}
                                 borderRadius="md"
                                 _hover={{ bg: 'blue.50' }}>
                                 {currentPage}
                              </Text>
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }} mx={1}>
                                 /
                              </Text>
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }}>
                                 {pagination?.totalPages || 1}
                              </Text>
                           </Flex>
                        ) : (
                           <Flex align="center">
                              <Input
                                 type="number"
                                 min={1}
                                 max={pagination?.totalPages || 1}
                                 value={pageInputValue}
                                 onChange={(e) => setPageInputValue(e.target.value)}
                                 onBlur={handlePageInputBlur}
                                 onKeyDown={handlePageKeyDown}
                                 fontSize={{ base: '14px', lg: '17px' }}
                                 width="40px"
                                 textAlign="center"
                                 p={0}
                                 border="2px solid"
                                 borderColor="blue.500"
                                 _focus={{ outline: 'none', ring: '1px', ringColor: 'blue.500' }}
                                 autoFocus
                              />
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }} mx={1}>
                                 /
                              </Text>
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }}>
                                 {pagination?.totalPages || 1}
                              </Text>
                           </Flex>
                        )}
                     </Flex>

                     {/* Next Page Button */}
                     <Box
                        onClick={() => handlePageChange('next')}
                        cursor={currentPage < (pagination?.totalPages || 1) ? 'pointer' : 'not-allowed'}
                        opacity={currentPage < (pagination?.totalPages || 1) ? 1 : 0.5}
                        role="button"
                        aria-label="Next page">
                        <MdNavigateNext size={28} />
                     </Box>
                  </Flex>

                  {/* Page Size Select */}
                  <Select
                     width="auto"
                     h={{ base: 9, lg: 10 }}
                     marginRight="5"
                     value={limit === pagination?.totalProducts ? 'ALL' : limit.toString()}
                     onChange={(e) => {
                        const newLimit = e.target.value === 'ALL' ? totalCount : Number(e.target.value);
                        setLimit(newLimit);
                        setCurrentPage(1); // Reset to first page when changing page size
                     }}>
                     <option value="10">10</option>
                     <option value="20">20</option>
                     <option value="30">30</option>
                     <option value="ALL">All</option>
                  </Select>

                  <IconButton
                     colorScheme="gray"
                     icon={<BsEye />}
                     size="md"
                     mr={1}
                     onClick={() => setIsColumnModalOpen(true)}
                  />

                  {/* Search Field */}
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '200px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{ marginRight: expanded ? '8px' : '10px', marginLeft: expanded ? '0' : '10px' }}
                     />
                     {expanded && (
                        <Input
                           variant="unstyled"
                           placeholder="Search..."
                           color={icon}
                           value={searchQuery}
                           onChange={handleSearchChange}
                           autoFocus
                        />
                     )}
                  </MotionFlex>

                  {/* Download + Column Visibility Menu */}
                  <Menu onDownloadPDF={downloadPDF} onDownloadExcel={downloadExcel} />
               </Flex>

               {isMobileOrTablet && (Admin || purchaseChallanRight?.add) && !user.isExpired && (
                  <Box position="fixed" bottom="4" right="4" zIndex={999}>
                     <button
                        onClick={() => navigate('/admin/purchase/challan/add')}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                           }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-cyan-100/20' : 'via-white/30'
                              }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark
                              ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                              : 'bg-white/20 group-hover:bg-white/30'
                              }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  </Box>
               )}
            </Flex>
            <Text display="flex" alignContent="center" justifyContent="center" borderTop="1px solid #ccc">
               {daybookTypeData?.map(
                  (item, i) =>
                     item.totalTaxableAmount !== 0 && (
                        <React.Fragment key={i}>
                           <Text as="span" color={item.totalTaxableAmount > 0 ? 'green.500' : 'red.500'}>
                              {item.daybookname} : {item.totalTaxableAmount} {item.totalTaxableAmount > 0 ? 'DB' : 'CR'}
                           </Text>
                           {i < daybookTypeData.length - 1 && (
                              <Text as="span" mx="1">
                                 |
                              </Text>
                           )}
                        </React.Fragment>
                     ),
               )}
            </Text>

            {/* Loading State - Updated with dynamic messages */}
            {shouldShowLoader ? (
               <Loader />
            ) : (
               <DynamicDataTable
                  singleEntityRights={purchaseChallanRight}
                  table={table}
                  tableData={data}
                  columnsData={columns}
                  emptyMessage="No Purchase challan data found"
                  handleViewSingleData={handleViewSingleData}
                  toggleDropdown={toggleDropdown}
                  onEditClick={(row) => {
                     localStorage.setItem('purchasechallanpage', currentPage);
                     navigate(`/admin/purchase/challan/edit/${row.id}`);
                  }}
                  onDeleteClick={(id) => {
                     const selectedData = data.filter((da) => da.id === id);
                     const selectedDaybook = daybookData.filter((dd) => dd.id === selectedData[0].daybookId);
                     if (selectedDaybook.length > 0 && selectedDaybook[0]?.askPasswordOnDelete) {
                        setDataId({
                           id: id,
                           daybookId: selectedData[0]?.daybookId,
                           accountId: selectedData[0]?.accountId,
                        });
                        setIsModalOpen(true);
                     } else {
                        deleteRecordForSales(
                           id,
                           selectedData[0]?.daybookId,
                           selectedData[0]?.accountId,
                           deletePurchaseChallan,
                           dispatch,
                           user?.loginhistory?.companyId,
                           userGlobalSettingsData,
                        );
                     }
                     // const selectedData = data.filter((da) => da.id === id);
                     // console.log('selectedData', selectedData);
                     // deleteRecordForSales(
                     //    id,
                     //    selectedData[0]?.daybookId,
                     //    selectedData[0]?.accountId,
                     //    deletePurchaseInvoice,
                     //    dispatch,
                     //    user?.loginhistory?.companyId,
                     // );
                  }}
                  onMultiDeleteClick={(data) => {
                     let daybookIds = [];
                     data?.forEach((item) => {
                        if (item?.daybookId && !daybookIds.includes(item.daybookId)) {
                           daybookIds.push(item.daybookId);
                        }
                     });

                     let requiresPassword = false;
                     daybookIds.forEach((id) => {
                        const selectedDaybook = daybookData.find((dd) => dd.id === id);
                        if (selectedDaybook?.askPasswordOnDelete) {
                           requiresPassword = true;
                        }
                     });

                     if (requiresPassword) {
                        setMultiDeleteData(data);
                        setMultiPass(true);
                     } else {
                        handleMultiDelete(data);
                     }
                  }}
                  onBillToBillClick={(row) => {
                     setAccountId(row.accountId);
                     setCompanyId(row.companyId);
                     setInvoiceData(row);
                     onOpenBillToBillModal();
                  }}
                  canDelete={true}
                  columnVisibility={columnVisibility}
                  type="purchaseChallan"
                  totalCount={pagination.total}
                  isLoading={isLoading}
               />
            )}
         </Box>

         {isOpen && (
            <div className="fixed inset-0 z-[999]">
               {isModalLoading ? (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               ) : (
                  <SalesDetails
                     isOpen={isOpen}
                     onClose={handleOnClose}
                     title="Purchase Challan"
                     entityType="purchasechallan"
                     singleEntity={singleEntity}
                     setIsEditFormOpen={setIsEditFormOpen}
                     setIsOpenSingleView={setIsOpenSingleView}
                     isEditFormOpen={isEditFormOpen}
                     handlePrevPage={handlePrevPage}
                     handleNextPage={handleNextPage}
                     paginate={paginateData}
                     viewDetail={viewDetail}
                     lineItems={viewDetail?.lineitems}
                     billTerms={viewDetail?.purchasebillteams}
                     onDelete={deletePurchase}
                     handleSerchClose={() => console.log('')}
                     handleViewSingleData={handleViewSingleData}
                     singleEntityRights={purchaseChallanRight}
                  />
               )}
            </div>
         )}

         {/* Filter Modal */}
         <SalesInvoiceFilterModal
            entityType="purchasechallan"
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            onApplyFilters={handleApplyFilters}
            initialFilters={filters}
            Totals={Totals}
         />
         <TransactionDetailModal
            isOpen={isBillToBillModal}
            onClose={handleOnCloseBillToBill}
            accountId={accountId}
            companyId={companyId}
            invoiceData={invoiceData}
            type="PURCHASE"
            page={currentPage}
            limit={limit}
         />

         <ColumnVisibilityModal
            isOpen={isColumnModalOpen}
            onClose={() => setIsColumnModalOpen(false)}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
            user={user}
         />

         <DeletePasswordModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={deleteRecordForSales}
            id={dataId}
            deleteApi={deletePurchaseChallan}
            dispatch={dispatch}
            type="purchase"
            userGlobalSettingsData={userGlobalSettingsData}
         />

         <MultiDeletePasswordModal
            isOpen={multiPass}
            onClose={() => {
               setMultiPass(false);
               setMultiDeleteData([]);
            }}
            onConfirm={() => handleMultiDelete(multiDeleteData)}
         />
      </>
   );
};

export default PurchaseInvoice;
